import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Input, styled } from '@mui/material'
import React, { FC, ReactNode } from 'react'
import { theme } from 'config'
import { Icon } from './icon'
import { useTranslation } from 'react-i18next'

export interface IConfirmDialogProps {
  onClose?:           () => void
  onConfirm?:         () => void
  onCancel?:          () => void
  open?:              boolean
  title?:             string
  confirmButtonText?: string
  cancelButtonText?:  string
  content?:           string | ReactNode
  confirmInput?:      ReactNode
  disabled?:          boolean
  loading?:           boolean
}

export const ConfirmDialog: FC<IConfirmDialogProps> = ({
  onClose,
  open,
  onCancel,
  onConfirm,
  title,
  confirmButtonText,
  cancelButtonText,
  content,
  confirmInput,
  disabled,
  loading
}) => {
  const { t } = useTranslation();
  return (
    <Dialog
      sx               = {{ alignItems: 'center' }}
      open             = {open}
      onClose          = {onClose}
      aria-labelledby  = 'alert-dialog-title'
      aria-describedby = 'alert-dialog-description'
    >
      <Box display='flex' justifyContent='flex-end' pb={0}>
        <CloseIcon onClick={onClose} iconId='remove' />
      </Box>
      <Box>
        <DialogTitle
          sx={{ textAlign: 'center', fontSize: theme.typography.h5 }}
          id='alert-dialog-title'
        >
          {title}
        </DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <DialogContentText sx={{mb: 1}} id='alert-dialog-description'>
            {content}
          </DialogContentText>
          {confirmInput}
        </DialogContent>
      </Box>
      <DialogActions
        sx={{
          display:        'flex',
          justifyContent: 'center',
          pb:             '2rem',
          gap:            '2rem',
        }}
      >
        {confirmButtonText && (
          <Button disabled={disabled} variant='contained' onClick={onConfirm}>
            {loading ? t('loading') : confirmButtonText}
          </Button>
        )}
        {cancelButtonText && (
          <Button variant='text' onClick={onCancel} autoFocus>
            {cancelButtonText}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

const CloseIcon = styled(Icon)`
  cursor: pointer;
`
